var _path, _mask, _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconStyles = function SvgIconStyles(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26921 10.0733C7.35897 10.2172 8.50851 10.2913 9.68296 10.2913C10.8705 10.2913 12.0353 10.2148 13.1413 10.0662L13.6333 3.3945C11.3802 2.11596 8.09479 2.06846 5.78391 3.2805L6.26921 10.0733ZM14.749 9.79028C15.1203 9.71177 15.4818 9.62432 15.8318 9.52812L16.2514 11.0545C15.7029 11.2053 15.1291 11.3361 14.5356 11.4462L15.713 18.0692L14.1543 18.3463L12.9697 11.6834C12.6775 11.7182 12.382 11.7484 12.0838 11.7738V16.6248H10.5005V11.8631C10.2292 11.8708 9.95657 11.8746 9.68296 11.8746C9.42658 11.8746 9.1712 11.8713 8.91713 11.8646V16.6248H7.33379V11.7788C6.97862 11.7494 6.62755 11.7133 6.28155 11.6707L4.94302 18.3633L3.39057 18.0522L4.71576 11.4262C4.18063 11.3241 3.66291 11.205 3.16675 11.0695L3.58396 9.54158C3.9321 9.63683 4.2921 9.72335 4.66231 9.80094L4.13487 2.4168L4.54337 2.16584C6.0032 1.2665 7.75279 0.791504 9.60212 0.791504C11.529 0.791504 13.4092 1.33063 14.8944 2.31071L15.2823 2.56642L14.749 9.79028Z",
    fill: "currentColor"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 0,
    width: 14,
    height: 19
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.26921 10.0733C7.35897 10.2172 8.50851 10.2913 9.68296 10.2913C10.8705 10.2913 12.0353 10.2148 13.1413 10.0662L13.6333 3.3945C11.3802 2.11596 8.09479 2.06846 5.78391 3.2805L6.26921 10.0733ZM14.749 9.79028C15.1203 9.71177 15.4818 9.62432 15.8318 9.52812L16.2514 11.0545C15.7029 11.2053 15.1291 11.3361 14.5356 11.4462L15.713 18.0692L14.1543 18.3463L12.9697 11.6834C12.6775 11.7182 12.382 11.7484 12.0838 11.7738V16.6248H10.5005V11.8631C10.2292 11.8708 9.95657 11.8746 9.68296 11.8746C9.42658 11.8746 9.1712 11.8713 8.91713 11.8646V16.6248H7.33379V11.7788C6.97862 11.7494 6.62755 11.7133 6.28155 11.6707L4.94302 18.3633L3.39057 18.0522L4.71576 11.4262C4.18063 11.3241 3.66291 11.205 3.16675 11.0695L3.58396 9.54158C3.9321 9.63683 4.2921 9.72335 4.66231 9.80094L4.13487 2.4168L4.54337 2.16584C6.0032 1.2665 7.75279 0.791504 9.60212 0.791504C11.529 0.791504 13.4092 1.33063 14.8944 2.31071L15.2823 2.56642L14.749 9.79028Z",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconStyles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_styles.e728c076.svg";
export { ForwardRef as ReactComponent };